import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SalonHeaderActions from './SalonHeaderActions';
import { resolveExperienceHubPath } from '../utils/salonHomeNav';
import { logoutFranchiseFlow } from '../../shared/franchiseFlowAuth';
import '../styles/salon-page-nav.css';
import './HairAnalyzeNavBar.css';

/**
 * Naturals salon top nav for Hair Analyze (/hair) — mirrors hub / makeup header.
 */
export default function HairAnalyzeNavBar() {
  const navigate = useNavigate();
  const [logoutBusy, setLogoutBusy] = useState(false);

  const goHub = () => {
    navigate(resolveExperienceHubPath());
  };

  const handleLogout = async () => {
    if (logoutBusy) return;
    setLogoutBusy(true);
    try {
      await logoutFranchiseFlow();
    } finally {
      navigate('/naturals/salon/login', { replace: true, state: {} });
      setLogoutBusy(false);
    }
  };

  return (
    <header className="hair-analyze-nav hair-analyze-page-nav">
      <div className="hair-analyze-nav__actions">
        <SalonHeaderActions
          homeButtonClassName="hair-analyze-nav__icon-btn hair-analyze-home-button"
          logoutButtonClassName="hair-analyze-nav__icon-btn"
          onHome={goHub}
          onLogout={handleLogout}
          logoutBusy={logoutBusy}
        />
      </div>
    </header>
  );
}
